import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import logo from "../assets/header.png";
import { defaultHomeSettings, normalizeHomeSettings } from "../utils/homeContent";
import { defaultSiteChromeSettings, normalizeSiteChromeSettings } from "../utils/siteChrome";

const API = "";

function Header() {
  const navigate = useNavigate();
  const [homeSettings, setHomeSettings] = useState(defaultHomeSettings);
  const [siteChrome, setSiteChrome] = useState(defaultSiteChromeSettings);

  useEffect(() => {
    let active = true;

    Promise.all([
      axios.get(`${API}/api/home-settings`),
      axios.get(`${API}/api/site-chrome-settings`),
    ])
      .then(([homeRes, chromeRes]) => {
        if (!active) return;
        setHomeSettings(normalizeHomeSettings(homeRes.data));
        setSiteChrome(normalizeSiteChromeSettings(chromeRes.data));
      })
      .catch(() => {
        if (!active) return;
        setHomeSettings(defaultHomeSettings);
        setSiteChrome(defaultSiteChromeSettings);
      });

    return () => {
      active = false;
    };
  }, []);

  const headerImage = homeSettings.banner_image ? `${API}/uploads/${homeSettings.banner_image}` : logo;

  return (
    <header className="site-header">
      <div className="site-topbar">
        <div className="site-topbar__inner">
          <div className="site-topbar__meta">
            <span>{siteChrome.topbar_phone}</span>
            <span>{siteChrome.topbar_email}</span>
            <span>{siteChrome.topbar_notice}</span>
          </div>

          <button type="button" className="site-topbar__button" onClick={() => navigate(siteChrome.topbar_button_link || "/contact")}>
            {siteChrome.topbar_button_text}
          </button>
        </div>
      </div>

      <div className="site-brandbar">
        <div className="site-brandbar__inner">
          <button
            type="button"
            className="site-brandbar__logo"
            onClick={() => navigate("/")}
            aria-label="Go to home page"
            style={{
              "--header-image-height-desktop": `${homeSettings.header_image_height_desktop || defaultHomeSettings.header_image_height_desktop}px`,
              "--header-image-height-mobile": `${homeSettings.header_image_height_mobile || defaultHomeSettings.header_image_height_mobile}px`,
            }}
          >
            <img src={headerImage} alt="NIDCS logo" />
          </button>
        </div>
      </div>
    </header>
  );
}

export default Header;
